export default "__VITE_ASSET__Swe$4fkY__"